import axios from "axios";
import { API_URL } from "../config/env";
import { lat2Cyr } from "../utils/functions";

export const getSiteSuggestions = async (token, search) =>
  axios
    .get(`${API_URL}/postcodes`, {
      params: { name: lat2Cyr(search) },
      headers: { Authorization: `Bearer ${token}` }
    })
    .then(({ data }) => data);

export const getSiteSuggestionsSpeedy = async (token, search, countryId = 100) =>
  axios.post(`${API_URL}/speedy/location/site`, { countryId, name: search }, { headers: { Authorization: `Bearer ${token}` } }).then(({ data }) => data.sites);

export const getBoxNowSiteSuggestions = async (token, search) =>
  axios
    .get(`${API_URL}/boxnow/cities`, {
      params: { name: lat2Cyr(search) },
      headers: { Authorization: `Bearer ${token}` }
    })
    .then(({ data }) => data);

export const getDestinationSuggestionsBoxNow = async (token, city, search, tenantId = "boleron") => {
  if (!city) return [];

  if (search) {
    return axios
      .get(`${API_URL}/boxnow/destinations`, {
        params: {
          city,
          name: search
        },
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(({ data }) => data);
  }

  return axios
    .get(`${API_URL}/boxnow/destinations`, {
      params: {
        city
        // name: lat2Cyr(search || "")
      },
      headers: { Authorization: `Bearer ${token}` }
    })
    .then(({ data }) => data);
};

export const getOfficeSuggestionsSpeedy = async (token, siteId, search, countryId = 100) => {
  if (siteId) {
    const results = await axios
      .post(`${API_URL}/speedy/location/office`, { countryId, siteId, name: search }, { headers: { Authorization: `Bearer ${token}` } })
      .then(({ data }) => data.offices);

    return results;
  }
  return [];
};

export const getSiteSuggestionsEcont = async (token, search) =>
  axios
    .post(`${API_URL}/econt/location/site`, {
      params: { name: lat2Cyr(search) },
      headers: { Authorization: `Bearer ${token}` }
    })
    .then(({ data }) => data);

export const getOfficeSuggestionsEcont = async (token, cityId, search) => {
  if (cityId) {
    const results = await axios
      .post(`${API_URL}/econt/location/office`, {
        params: { cityId, name: search },
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(({ data }) => data);
    return results;
  }

  return [];
};
